import { IObject } from 'src/models/objectManagement';

// this will return concatenation of two object with no duplicate id
export const concatUniqueObjectsById = (arr1: IObject[], arr2: IObject[]) => {
  const uniqueIds = new Set(arr1.map((item) => item['id']));
  const uniqueArray = arr2.filter((item) => !uniqueIds.has(item['id']));
  return arr1.concat(uniqueArray);
};
